import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { CTA } from '../../interfaces/CTA.interface';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import classNames from 'classnames';

interface ProgressBarProps {
  totalSteps: number;
  quoteStep: number;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ totalSteps, quoteStep }) => {
  return (
    <div
      className={classNames('flex gap-x-0 transition-all duration-300', {
        'gap-x-3': quoteStep !== 0,
      })}
    >
      {[...Array(totalSteps).keys()].map((_, idx) => {
        return (
          <div
            style={{
              gridTemplateColumns: `repeat(${totalSteps}, minmax(0, 1fr))`,
            }}
            className={classNames('h-2 w-full bg-progress/incomplete', {
              '!bg-progress/complete': idx === quoteStep && quoteStep !== 0,
              'rounded-full': quoteStep !== 0,
              'rounded-l-full': quoteStep === 0 && idx === 0,
              'rounded-r-full': quoteStep === 0 && idx + 1 === totalSteps,
            })}
            key={`${idx}-p-bar`}
          ></div>
        );
      })}
    </div>
  );
};

export default withBlokWrapper(ProgressBar, Theme.ALT);
